import { FieldType } from '../mdf/fieldDefinition';

/** What a metadata field does with an AND or OR the user types between two of its values. */
export interface OperatorCapability {
  /** Whether the typed operator changes the search at all. */
  honoursOperator: boolean;
  /** Whether an item can hold more than one value here. Without it, AND can never match. */
  multiValued: boolean;
}

/** Exhaustive, so adding a field type does not compile until someone decides how it treats a
 *  typed operator. */
export const OPERATOR_CAPABILITY: Record<FieldType, OperatorCapability> = {
  [FieldType.Choice]: { honoursOperator: true, multiValued: false },
  [FieldType.MultipleChoice]: { honoursOperator: true, multiValued: true },
  [FieldType.Checkbox]: { honoursOperator: false, multiValued: false },
  [FieldType.SubType]: { honoursOperator: false, multiValued: false },
  [FieldType.Text]: { honoursOperator: false, multiValued: true },
  [FieldType.Date]: { honoursOperator: false, multiValued: true },
  [FieldType.Number]: { honoursOperator: false, multiValued: true },
  [FieldType.User]: { honoursOperator: false, multiValued: true },
  [FieldType.TreeChoice]: { honoursOperator: false, multiValued: true },
  [FieldType.Link]: { honoursOperator: false, multiValued: true },
  [FieldType.File]: { honoursOperator: false, multiValued: true },
  [FieldType.Button]: { honoursOperator: false, multiValued: true },
  [FieldType.JSON]: { honoursOperator: false, multiValued: true },
};
